import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { Checkbox } from 'redux-form-material-ui'
import CheckboxMaterial from 'material-ui/Checkbox'
import CheckIcon from 'material-ui/svg-icons/action/check-circle'
import CircleIcon from 'material-ui/svg-icons/toggle/radio-button-unchecked'
import BadIcon from 'material-ui/svg-icons/action/highlight-off'
import { missionPEOField } from '../../../../../../utils/constants'

const iconForCheckBox = (peo, answer) => {
  if (!peo) {
    return CircleIcon
  }
  const isResponded = answer && answer.selected
  if (peo.is_correct_answer && isResponded) {
    return CheckIcon
  } else if (!peo.is_correct_answer && isResponded) {
    return BadIcon
  } else if (peo.is_correct_answer && !isResponded) {
    return CircleIcon
  } else if (!peo.is_correct_answer && !isResponded) {
    return CircleIcon
  }
  return CircleIcon
}

const styleForCheckBox = (peo, answer) => {
  if (!peo) {
    return {}
  }
  const isResponded = answer && answer.selected
  if (peo.is_correct_answer && isResponded) {
    return { fill: 'green' }
  } else if (!peo.is_correct_answer && isResponded) {
    return { fill: 'red' }
  } else if (peo.is_correct_answer && !isResponded) {
    return { fill: 'green' }
  } else if (!peo.is_correct_answer && !isResponded) {
    return {}
  }
  return {}
}

const isCheckBoxChecked = (peo, answer) => {
  if (!peo) {
    return false
  }
  const isResponded = answer && answer.selected
  if (peo.is_correct_answer && isResponded) {
    return true
  } else if (!peo.is_correct_answer && isResponded) {
    return true
  } else if (peo.is_correct_answer && !isResponded) {
    return true
  } else if (!peo.is_correct_answer && !isResponded) {
    return false
  }
  return false
}

class CheckBoxElement extends React.Component {

  render() {
    const { element, real_answer } = this.props
    if (real_answer && real_answer.page_element_options) {
      return (
        <div>
          {element.page_element_options.map((peo) => {
            let peo_answer = null
            real_answer.page_element_options.forEach((real_peo) => {
              if (real_peo.id === peo.id) {
                peo_answer = real_peo
              }
            })
            const IconToDraw = iconForCheckBox(peo, peo_answer)
            return (
              <CheckboxMaterial
                label={peo.option_value}
                iconStyle={styleForCheckBox(peo, peo_answer)}
                checkedIcon={<IconToDraw />}
                uncheckedIcon={<IconToDraw />}
                checked={isCheckBoxChecked(peo, peo_answer)}
                onCheck={() => {}}
              />
            )
          })}
        </div>
      )
    }
    return (
      <div>
        {element.page_element_options.map(peo =>
          <Field
            key={peo.id}
            name={missionPEOField(element, peo)}
            component={Checkbox}
            label={peo.option_value}
          />,
          )}
      </div>
    )
  }

}

CheckBoxElement.propTypes = {
  element: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
    has_answer: React.PropTypes.bool.isRequired,
    page_element_options: React.PropTypes.arrayOf(React.PropTypes.shape({
      id: React.PropTypes.number.isRequired,
      is_correct_answer: React.PropTypes.bool.isRequired,
      option_value: React.PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(CheckBoxElement)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/PageElement/CheckBoxElement/index.jsx